module.exports = __webpack_public_path__ + "img/inActive-list.0c568678.svg";